module.exports = "/images/68129ab319dced54699d7eed059e6ff2.png";